import React from "react";
import "../../styles/facilitatorKRAView.scss";
import { useEffect } from "react";
import api from "../../utils/api";
import { useState } from "react";
import { toast } from "react-toastify";
import { getUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import Spinner from "../../common/Spinner/Spinner";
import { Button } from "../../common/Button/Button";
import Select from "react-select";
import quality_analysis from "./../../assets/quality_analysis.csv";
import system_update from "./../../assets/system_update.csv";
import KRA_targets from "./../../assets/KRA_targets.csv";

export default function AdminUploadReport(props)
{
    const ref = React.useRef();
    const [isLoading, setIsLoading] = useState(false);
    const[activePage,setActivePage]=useState(""); 
    const history = useHistory();
    const [UploadReportFile,setUploadReportFile] = useState();
    const [ReportTypeOptions,setReportTypeOptions,] = useState([
		{
			value: "system_update",
			label: "System Updates",
		},
		{
			value: "quality_analysis",
			label: "Quality Analysis",
		},
        {
			value: "targets",
			label: "Targets",
		},
	]);

    const [TargetTypeOptions,setTargetTypeOptions,] = useState([
		{
			value: "month_data",
			label: "Monthly Data",
		},
		{
			value: "quarter_data ",
			label: "Quarterly Data ",
		},
	]);

	const [selectedReportTypeOption,setSelectedReportTypeOption,] = useState({
		value: "system_update",
		label: "System Updates",
	});

    const [selectedTargetTypeOption,setSelectedTargetTypeOption,] = useState({
        value: "month_data",
        label: "Monthly Data",
	});

    useEffect(() => {
        if (!getUser()) 
        {
			history.push("/login");
		}
        else
        {
            const user = getUser();
            const hasFacilitatorKRARole = user.role.includes(10);
            if (hasFacilitatorKRARole) 
            {
                setActivePage("UploadReportView");
            }
            else
            {
                setActivePage("No_Access");
            } 
        }
	},[]);

    
    const handleDownloadSampleFile = async () => {
        window.open(quality_analysis, "_self");
	};

	const onUploadReport = () => {
		if (!UploadReportFile) 
        {
            toast("Please select file.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }
        let extension =UploadReportFile.name.substring(UploadReportFile.name.lastIndexOf('.')+1, UploadReportFile.name.length) ||"";
        if(extension!='csv')
        {
            ref.current.value = "";
            setUploadReportFile(null);
            toast("Please select csv file.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
            return;
        }
        
        var formData = new FormData();
		formData.append("dashboard_report",UploadReportFile,UploadReportFile.name);
        formData.append("excel_file_type",selectedReportTypeOption.value);
        if(selectedReportTypeOption.value=='targets')
        {
            if(selectedTargetTypeOption.value=='month_data')
            {
                formData.append("month_data",true);
            }
            else
            {
                formData.append("quarter_data",true);
            }
        }
		setIsLoading(true);
		const data = api
			.UploadAdminKRAReport(formData)
			.then(({ data }) => {
                let sv=data;
                setIsLoading(false);
                ref.current.value = "";
                setUploadReportFile(null);
                if(data&&data.message)
                {
                    if(data.message=='File uploaded and processed successfully')
                    {
                        toast(data.message, {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                    }
                    else
                    {
                        toast(data.message, {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }                    
                }
                else
                {
                    toast("File uploaded successful", {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    });
                }
			})
			.catch((error) => {
                setIsLoading(false);
                if(error&&error.response&&error.response.data&&error.response.data.message)
                {
                    toast(error.response.data.message, {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
                else{
                    toast("Internal server error", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
			});
	};

	const onFileSelected = (e) => {
		console.log("files", e.target.files);
		setUploadReportFile(e.target.files[0]);
	};

    return(
        <>        
        {
            activePage==="UploadReportView"?
            (
                <div className={`${isLoading && "set-opacity"}`}>
                    {isLoading && <Spinner className="center-screen" />}
                    <div className="row"style={{marginTop:"10px"}}>
                        <div className="col-12 admin-upload-report"> 
                            <Select
                                options={ ReportTypeOptions }
                                onChange={(option) => {
                                    setSelectedReportTypeOption(option);
                                }}
                                value={selectedReportTypeOption}
                            />
                            {selectedReportTypeOption.value==='targets'&&
                            (<Select
                                options={ TargetTypeOptions }
                                onChange={(option) => {
                                    setSelectedTargetTypeOption(option);
                                }}
                                value={selectedTargetTypeOption}
                            />)}
                            <input className="form-control-custom" ref={ref} type="file"
                                accept=".csv"
                                onChange={onFileSelected}></input>                            
                            <Button onClick={onUploadReport}>Upload</Button> 
                            {selectedReportTypeOption.value==="system_update"?
                            (
                                <a href={system_update} download="system_update.csv"> Download Sample File </a>
                            ):
                            selectedReportTypeOption.value==="targets"?
                            (
                                <a href={KRA_targets} download="KRA_targets.csv"> Download Sample File </a>
                            )
                            :(
                                <a href={quality_analysis} download="quality_analysis.csv"> Download Sample File </a>
                            )} 
                            
                        </div>
                    </div>
                </div>
            )
            :
            activePage==="No_Access"?
            (
                <div className={`row row-container`}>
                        <div className="col-12 row-margin-10px" style={{textAlign:"center"}}>                                
                        <label>
                            <b>You are not allowed to access this page, Please contact admin for more details.</b>
                        </label>         
                    </div>
                </div>
            )
            :
            (
                ""
            )}
        </>
    );
}